import React from "react"
import { View, StyleSheet } from "react-native"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { daysUntilBrevet } from "../utils/countdownToBrevet"

const BrevetCountdownBanner = ({ style }) => {
    const days = daysUntilBrevet()
    if (days <= 0) return null
    return (
        <View style={[styles.banner, style]}>
            <FontAwesome5 name="clock" size={12} color={theme.colors.warning} />
            <TextM
                fontWeight="Bold"
                fontSize={12}
                color={theme.colors.warning}
                style={{ marginLeft: 6 }}
            >
                Brevet dans {days} jours
            </TextM>
        </View>
    )
}

const styles = StyleSheet.create({
    banner: {
        flexDirection: "row",
        alignItems: "center",
        alignSelf: "flex-start",
        backgroundColor: theme.colors.warningLight,
        paddingHorizontal: 12,
        paddingVertical: 8,
        borderRadius: 12,
        marginBottom: 16,
    },
})

export default BrevetCountdownBanner
